<script setup>
    import { useWebStore } from '~/store/web';
    const store = useWebStore();
    const isGdprOpen = ref(false)
    store.chosenTab = store.sites[7].url
    const showModal = true;
</script>
<template>
        <div class=" h-3/4 bg-white overflow-y-auto">
            <h1 class="InterExtraBold text-4xl my-8">{{store.getLocaleString('cp1')}}</h1>
            <ClientOnly>
                    <div class="w-max mx-auto flex flex-col gap-5 ">
                        <Pdf class="" url="panaszkezelesi-szabalyzat.pdf"></Pdf>
                    </div>
            </ClientOnly>
        </div>
        <FooterComp/>
</template>